import {Stack} from "@mui/material"
import React, {useContext, useEffect, useState} from "react"
import {DataContext} from "../../../context/DataContextProvider"
import SchadenhistorieFilter from "./Schadenshistorie/SchadenshistorieFilter"
import {getMerkmal} from "../../../../anwendungskonfigurator/misc/widget-functions"
import SchadenhistorieTable from "./Schadenshistorie/SchadenshistorieTable"
import {ActionContext} from "../../../context/ActionContextProvider"

const SchadenhistorieWidget = ({widget}) => {
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const {triggerAction} = useContext(ActionContext)
    const [selectedEreignisse, setSelectedEreignisse] = useState([])
    const ereignisListPointer = getMerkmal(widget)?.pointer
    const ereignisse = getDataFromPointer(ereignisListPointer)

    const updateSchadensereignisseAndSaveInBackend = (
        newSelectedEreignisnummer,
    ) => {
        ereignisse.map((ereignis) => {
            const updatedEreignis = {
                ...ereignis,
                aufwandSelektiert: newSelectedEreignisnummer.includes(
                    ereignis.ereignisnummer,
                ),
            }
            updateData(
                updatedEreignis,
                ereignisListPointer + "/" + (ereignis.ereignisnummer - 1),
            )
            triggerAction("TOGGLE_SCHADENSEREIGNIS", updatedEreignis)
        })
    }

    const tableRows = ereignisse
        ?.filter((ereignis) => ereignis.aufwandSelektiert)
        .flatMap((ereignis) => {
            const {schadenjahr, ereignisnummer} = ereignis

            return ereignis?.deckung?.map((deckungEntry, deckungindex) => ({
                schadenjahr: schadenjahr,
                ereignisnummer: ereignisnummer,
                ereignisArrayEntry: ereignisnummer - 1,
                deckungArrayEntry: deckungindex,
                ...deckungEntry,
            }))
        })

    useEffect(() => {
        setSelectedEreignisse(
            ereignisse
                ?.filter((ereignis) => ereignis.aufwandSelektiert)
                ?.map((ereignis) => ereignis.ereignisnummer) ?? [],
        )
    }, [JSON.stringify(ereignisse)])
    const onFilterChange = (newFilter) => {
        setSelectedEreignisse(newFilter)
        updateSchadensereignisseAndSaveInBackend(newFilter)
    }
    return (
        <Stack>
            <SchadenhistorieFilter
                widget={widget}
                value={selectedEreignisse}
                onValueChange={onFilterChange}
                options={ereignisse ?? []}
            />
            <SchadenhistorieTable rows={tableRows} />
        </Stack>
    )
}

export default SchadenhistorieWidget
